import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=76cdd6e6&scoped=true&"
import script from "./badge.vue?vue&type=script&lang=ts&"
export * from "./badge.vue?vue&type=script&lang=ts&"
import style0 from "./badge.vue?vue&type=style&index=0&id=76cdd6e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cdd6e6",
  null
  
)

export default component.exports